export default __webpack_public_path__ + "static/media/video.fd3bc19f.svg";